module.exports = __webpack_public_path__ + "static/img/logo-img.2e05a7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-img.png
// module id = 2Xsp
// module chunks = 1